<template>
  <div id="Table" class="Table">
    <div style="height: 500px; overflow-y: auto">
      <el-table ref="filterTable" :data="orderList" style="width: 100%" :height="'500'">
        <el-table-column
          v-for="item in columeList"
          v-if="item.isSelected"
          :prop="item.field"
          :width="item.width"
          :label="item.value"
          :fixed="item.fixed"
        >
          <template slot-scope="scope">
            <el-link v-if="item.isLink" @click="toOrder(scope.row)">{{
              scope.row[item.field]
            }}</el-link>
            <span
              v-else-if="!item.isCargo"
            >{{ scope.row[item.field]=="Pending"?"-":scope.row[item.field] }}</span>
            <span
              v-else
            >{{ scope.row.totalQuantity }}件|{{ scope.row.totalWeight }}KG|{{ scope.row.totalVolume }}CBM</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status>1"
              type="text"
              size="small"
              @click="toOrder(scope.row)"
            >详情</el-button>
            <el-button
              v-if="scope.row.status==1"
              type="text"
              size="small"
              @click="toOrder(scope.row)"
            >编辑</el-button>
            <el-button
              v-if="scope.row.status>1&&scope.row.status<5"
              type="text"
              size="small"
              @click="download(scope.row)"
            >打印箱唛</el-button>
            <el-button v-if="scope.row.status<3" type="text" size="small">取消</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      :current-page="listQuery.currentPage"
      :page-size="listQuery.pageSize"
      layout="prev, pager, next"
      :total="total"
      style="margin-top: 25px"
      @current-change="handleCurrentChange"
    />
    <ExpOrder
      v-if="businessType == 1"
      ref="ExpOrder"
      @close="
        () => {
          businessType = 0;
        }
      "
    />
    <AirOrder
      v-if="businessType == 2"
      ref="AirOrder"
      @close="
        () => {
          businessType = 0;
        }
      "
    />
    <FBAOrder
      v-if="businessType == 3"
      ref="FBAOrder"
      @close="
        () => {
          businessType = 0;
        }
      "
    />
    <SeaOrder
      v-if="businessType == 4"
      ref="SeaOrder"
      @close="
        () => {
          businessType = 0;
        }
      "
    />
  </div>
</template>

<script>
import request from '@/utils/request'
import FBAOrder from '@/client/home/placeAnOrder/fba/confirmOrder.vue'
import ExpOrder from '@/client/home/placeAnOrder/exp/confirmOrder.vue'
import AirOrder from '@/client/home/placeAnOrder/air/confirmOrder.vue'
import SeaOrder from '@/client/home/placeAnOrder/sea/confirmOrder.vue'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'Table',
  components: {
    // 组件的引用
    FBAOrder,
    ExpOrder,
    AirOrder,
    SeaOrder
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      token: '',
      orderList: [],
      columeList: [],
      total: 0,
      listQuery: {
        status: 1,
        keywords: '',
        currentPage: 1,
        pageSize: 20,
        sort: 'desc',
        sidx: ''
      },
      List: [{
        id: 1,
        name: '订单详情',
        isActive: false
      },
      {
        id: 2,
        name: '查看账单',
        isActive: false
      },
      {
        id: 3,
        name: '查看报价',
        isActive: false
      },
      {
        id: 4,
        name: '查看轨迹',
        isActive: false
      }
      ],
      businessType: 0
    }
  },
  watch: {},
  mounted() {},
  created() {
    // 实例被创建之后执行代码
    this.token = getCookie('token')
    if (this.token) {
      this.getOrderInfo()
      var columeList = JSON.parse(localStorage.getItem('columeList'))
      if (columeList != null) {
        this.columeList = columeList
      }
    }
  },
  methods: {
    download(row) {
      request({
        url: `/api/webapi/Order/GetMarkUrl`,
        method: 'GET',
        data: {
          id: row.orderNo
        },
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        if (res.code == 200 && res.data != null) {
          this.xms.downloadFile(res.data)
        }
      })
    },
    updateSort() {
      var columeList = JSON.parse(localStorage.getItem('columeList'))
      if (columeList != null) {
        this.columeList = columeList
      }
    },
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getOrderInfo()
    },
    change(index) {
      if (index == 0) {
        this.listQuery.status = 2
        this.listQuery.currentPage = 1
        this.getOrderInfo()
      } else if (index == 1) {
        this.listQuery.status = 1
        this.listQuery.currentPage = 1
        this.getOrderInfo()
      } else if (index == 2) {
        this.listQuery.status = 0
        this.listQuery.currentPage = 1
        this.getOrderInfo()
      }
    },
    search(data) {
      this.listQuery.keywords = data
      this.getOrderInfo()
    },
    getOrderInfo() {
      request({
        url: `/api/shipping/PersonOrder`,
        method: 'GET',
        data: this.listQuery,
        headers: {
          Authorization: this.token
        }
      }).then((res) => {
        if (res.data != null) {
          this.orderList = res.data.list
          this.total = res.data.pagination.Total
        }
      })
    },
    toOrder(row, orderIndex) {
      this.businessType = row.businessType
      switch (row.businessType) {
        case 1:
          this.$nextTick(() => {
            this.$refs.ExpOrder.initOrder(row.orderNo, orderIndex)
          })
          break
        case 2:
          this.$nextTick(() => {
            this.$refs.AirOrder.initOrder(row.orderNo, orderIndex)
          })
          break
        case 3:
          this.$nextTick(() => {
            this.$refs.FBAOrder.initOrder(row.orderNo, orderIndex)
          })
          break
        case 4:
          this.$nextTick(() => {
            this.$refs.SeaOrder.initOrder(row.orderNo, orderIndex)
          })
          break
      }
    },
    resetDateFilter() {
      this.$refs.filterTable.clearFilter('date')
    },
    clearFilter() {
      this.$refs.filterTable.clearFilter()
    },
    formatter(row, column) {
      return row.address
    },
    filterTag(value, row) {
      return row.tag === value
    },
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    }
  }
}
</script>
<style lang="scss">
	.tablepopover {
		min-width: 0px !important;
		padding: 0px !important;
		border: 0px !important;
	}
</style>
<style scoped lang="scss">
	::v-deep .el-table td {
		padding: 0px !important;
		border-bottom: 1px solid rgba(221, 221, 221, 0.56) !important;
	}

	::v-deep .el-table th {
		background: #f7f7f7;
		height: 32px !important;
		padding: 0px !important;
	}

	::v-deep .el-table__fixed,
	.el-table__fixed-left {
		background-color: #fff !important;
		height: 484px !important;
	}

	::v-deep .el-table__fixed-right {
		background-color: #fff !important;
		height: 484px !important;
	}

	::v-deep .el-link.el-link--default {
		color: #3370ff;
	}

	::v-deep .el-table .el-table__body-wrapper::-webkit-scrollbar {
		/*滚动条整体样式*/
		// width: 4px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 16px;
	}

	::v-deep .el-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 8px;
		box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
		-webkit-box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
		background: #e0e0e0;
	}

	::v-deep .el-table .el-table__body-wrapper::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		//  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
		// -webkit-box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08) inset;
		border-radius: 8px;
		background: #fff;
	}

	.columns-panle {
		width: 176px;
		height: 120px;
		background: #ffffff;
		box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
		border-radius: 8px;
		position: absolute;
		top: -25px;
		left: -150px;
		z-index: 20;
		padding: 8px;

		.list-item {
			height: 30px;
			line-height: 30px;
			background: rgba(255, 255, 255, 0);
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 13px;
			color: #333333;
			line-height: 20px;
			text-align: left;
			display: flex;
			align-items: center;
			padding: 0px 8px;
			cursor: pointer;

			&:hover {
				background: #f7f8fa;
				border-radius: 4px;
			}
		}
	}
</style>
